import type { SetStateAction } from 'react';

import Api from 'services/api';

export const shareBiddings = async (
  biddingsIds: Array<number>,
  sharedTo: string,
  setShowProgress: (value: SetStateAction<boolean>) => void,
  setShowError: (value: SetStateAction<boolean>) => void,
  setShowSuccess: (value: SetStateAction<boolean>) => void,
  companyId: number,
  selectedBulletin: boolean = false,
  shareHtml?: string,
) => {
  const share: Record<string, unknown> = {
    biddings_ids: biddingsIds,
    selected_bulletin: selectedBulletin,
    shared_to: sharedTo,
    companyId,
  };

  if (shareHtml != null && shareHtml.trim() !== '') {
    share.checklist_html = shareHtml;
  }

  const params = { share };
  const response = await Api.post('/minhas_licitacoes/shares', params);

  setShowProgress(false);

  if (response?.status !== 201) return setShowError(true);

  return setShowSuccess(true);
};

export const shareFollowups = async (
  followupIds: Array<number>,
  sharedTo: string,
  setShowProgress: (value: SetStateAction<boolean>) => void,
  setShowError: (value: SetStateAction<boolean>) => void,
  setShowSuccess: (value: SetStateAction<boolean>) => void,
  companyId: number,
  selectedBulletin: boolean = false,
) => {
  const params = {
    share: {
      followups_ids: followupIds,
      selected_bulletin: selectedBulletin,
      shared_to: sharedTo,
      companyId,
    },
  };
  const response = await Api.post('/minhas_licitacoes/shares', params);

  setShowProgress(false);

  if (response?.status !== 201) return setShowError(true);

  return setShowSuccess(true);
};
